function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_83",
  "data-name": "Grupo 83",
  transform: "translate(0 11)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_3",
  "data-name": "Trazado 3",
  d: "M5227.457,472.995H5175v-59.8c0-2.892-2.8-5.236-6.246-5.236H5062.528c-3.448,0-6.25,2.344-6.25,5.236v65.147c0,2.892,2.8,5.236,6.25,5.236h5.755c3.455,0,6.251-2.344,6.251-5.236V451.28h39.147c3.45,0,6.248-2.344,6.248-5.236s-2.8-5.236-6.248-5.236h-39.147V418.43h82.215v59.911c0,2.892,2.8,5.236,6.25,5.236h64.458c3.449,0,6.248-2.344,6.248-5.236v-.11C5233.7,475.339,5230.906,472.995,5227.457,472.995Z",
  transform: "translate(-5056.279 -397.658)",
  fill: "#050358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_4",
  "data-name": "Trazado 4",
  d: "M5636.3,407.958H5520.039c-3.449,0-6.246,2.344-6.246,5.236v65.147c0,2.892,2.8,5.236,6.246,5.236h5.759c3.448,0,6.247-2.344,6.247-5.236v-59.8H5586.8v59.8c0,2.892,2.8,5.236,6.247,5.236h5.757c3.449,0,6.247-2.344,6.247-5.236v-59.8H5636.3c3.45,0,6.248-2.344,6.248-5.236v-.11C5642.544,410.3,5639.747,407.958,5636.3,407.958Z",
  transform: "translate(-5323.044 -397.658)",
  fill: "#050358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_5",
  "data-name": "Trazado 5",
  d: "M5518.468,379.909h32.886c3.63,0,6.577-2.467,6.577-5.511s-2.947-5.512-6.577-5.512h-32.886c-3.635,0-6.579,2.468-6.579,5.512S5514.833,379.909,5518.468,379.909Z",
  transform: "translate(-5321.024 -379.886)",
  fill: "#050358"
}));

var SvgBigLogo = function SvgBigLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319.5,
    height: 96.919,
    viewBox: "0 0 319.5 96.919",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/big-logo.31c3d964.svg";
export { ForwardRef as ReactComponent };